<template>
  <div class="panel panel-default">
    <div class="panel-body ">
      <div class="row">
        <form class="form-horizontal" style="padding-top:10px" id="bs_form">
          <div class="col-sm-3">
            <div class="form-group">
              <label class="col-sm-3 control-label">关键字</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  v-model="query.ksWord"
                  name="name"
                  class="form-control"
                  placeholder="身份证/名字"
                />
              </div>
            </div>
          </div>


          <div class="col-sm-3">
            <div >
              <button
                type="button"
                class="btn btn-primary btn-sm"
                style="margin-right:3px"
                @click="search()"
              >
                <i class="fa fa-search" aria-hidden="true"></i>查询
              </button>
            </div>
          </div>
        </form>
      </div>
      
      <div class="row">
        <div class="col-sm-12" style="padding-top: 10px">
          <BootstrapTable
            style="font-size: 14px;"
            ref="table"
            :columns="columns"
            v-once
            :options="{
              classes: 'table table-hover',
              undefinedText: '',
              showColumns: false,
              sidePagination: 'server',
              pagination: true,
              pageNumber: 1,
              pageSize: 10,
              pageList: [10, 50, 100, 500],
              paginationPreText: '上一页',
              paginationNextText: '下一页',
              showExtendedPagination: true,
              paginationLoop: false,
            }"
            @onPostBody="vueFormatterPostBody"
            @onPageChange="pageChange"
            @onClickRow="clickRow"
          />
        </div>
      </div>
    </div>
    <StudentFeeView ref="StudentFeeView"></StudentFeeView>
  </div>
</template>
<script>
/**
 * 考生缴费管理
 */
import tableMixin from "@/mixins/table.js";
import { checkTypeMap } from "@/plugins/enums.js";
import StudentFeeView from "./StudentFeeView";
export default {
  mixins: [tableMixin],
  name: "StudentFeeList",
  components: {
    StudentFeeView,
  },
  data: function() {
    return {
      query: {
        ksWord:""
      },

      columns: [
        {
          title: "序号",
          field: "id",
          align: "center",
          formatter: (value, row, index) => {
            var options = this.$refs.table.getOptions();
            return options.pageSize * (options.pageNumber - 1) + index + 1;
          },
        },
        {
          field: "xm",
          title: "姓名",
        },
        {
          field: "sfzh",
          title: "身份证号码",
          width: 130,
        },
        {
          field: "zymc",
          title: "报考专业",
          formatter: (value, row) => {
            if (row.zkxxdm && row.zkxxmc) {
              return row.zydm + "-" + row.zymc;
            }
            return "";
          },
        },
        {
          field: "zkxxdm",
          title: "主考学校",
          formatter: (value, row) => {
            if (row.zkxxdm && row.zkxxmc) {
              return row.zkxxdm + "-" + row.zkxxmc;
            }
            return "";
          },
        },
        {
          field: "zxjgdm",
          title: "助学机构",
          formatter: (value, row) => {
            if (row.zxjgdm && row.zxjgmc) {
              return row.zxjgdm + "-" + row.zxjgmc;
            }
            return "";
          },
        },
        {
          field: "shzt",
          title: "审核状态",
          formatter: (value, row, index) => {
            return checkTypeMap[value];
          },
        },
        {
          field: "xxxsmc",
          title: "学习形式",
        },
        {
          field: "ndm",
          title: "年度码",
        },
        {
          field: "zczt",
          title: "注册状态",
          formatter: (value) => {
            let bmzt = value;
            if (bmzt == "UNREGISTERED_UNPAID") {
              bmzt = "未注册/待缴费";
            } else if (bmzt == "INFO_WRONG") {
              bmzt = "信息错误";
            } else if (bmzt == "INFOUPDATE_APPLY") {
              bmzt = "信息修改申请";
            } else if (bmzt == "INFOUPDATE_AUDIT") {
              bmzt = "待审核";
            } else if (bmzt == "REGISTERED_UNPAID") {
              bmzt = "已注册/待缴费";
            } else if (bmzt == "REGISTERED") {
              bmzt = "已注册";
            }

            return bmzt;
          },
        },
        {
          field: "actions",
          title: "操作",
          width: "220px",
          align: "center",
          formatter: (value, row) => {
            return this.vueFormatter({
              template:
                '<div class="operation_column">' +
                '<a @click="view(row)">缴费记录</a> </div>',
              data: { row },
              methods: {
                view: this.view,
              },
            });
          },
        },
      ],
    };
  },
  mounted() {
    this.query = Object.assign(
      this.query,
      { current: 1, size: 10 },
      this.$route.query
    );
    this.load();
  },
  beforeRouteUpdate(to, from, next) {
    this.query = Object.assign(this.query, { current: 1, size: 10 }, to.query);
    this.load();
    next();
  },
  created: function() {
    this.$store.commit("setBreadcrumb", [
      { name: "自学考试" },
      { name: "考生注册管理" },
      { name: "考生缴费管理" },
    ]);
  },
  methods: {
    view(row) {
      this.$refs.StudentFeeView.open(row);
    },

    search: function() {
      //将数据表格的页码以及每一页展示的数据重置为1，10
      let query = Object.assign(
        this.query,
        { current: 1, size: 10 },
        { _t: new Date().getTime() }
      );
      this.$router.push({ name: this.$route.name, query: query });
    },
    //返回表格数据
    load: function(pageNumber, pageSize) {
      this.query.current = pageNumber || this.query.current;
      this.query.size = pageSize || this.query.size;
      this.$http.post("/htgl/biz/zypx/bm/fycx", this.query).then((res) => {
        let data = res.data;
        //封装返回值
        let result = {
          total: data.total,
          rows: data.records,
        };
        //table加载返回的数据
        this.$refs.table.load(result);
        this.$refs.table.refreshOptions({
          pageNumber: parseInt(this.query.current),
          pageSize: parseInt(this.query.size),
        });
      });
    },
    pageChange: function(pageNumber, pageSize) {
      let query = Object.assign(
        this.query,
        { current: pageNumber, size: pageSize },
        { _t: new Date().getTime() }
      );
      this.$router.push({ name: this.$route.name, query: query });
    },
  },
};
</script>
